import React, { useState, useRef, useContext, useEffect } from "react";
import { MyContext } from "../../../../MyContextApi";
import Skeleton from "@mui/material/Skeleton";
import Box from "@mui/material/Box";
import api from "../../../../API/axiosInstance";
import { generateHash } from "../../../../API/hashUtil";
// import {Skeleton} from "@mui/material";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import RedoIcon from "@mui/icons-material/Redo";
import UndoIcon from "@mui/icons-material/Undo";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TablePagination from "@mui/material/TablePagination";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faExpand,
  faMinimize,
  faServer,
  faUserCog,
} from "@fortawesome/free-solid-svg-icons";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import { styled } from "@mui/material/styles";
import { Tooltip } from "@mui/material";
// const apiUrl = "http://10.226.39.57:8080";
// Styled Components
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#1AACAC",
    color: theme.palette.common.white,
    textAlign: "center", // Centers text in the header cells
    verticalAlign: "middle", // Centers text vertically
    fontWeight: "bold",
    fontSize: "1rem",
    padding: theme.spacing(1.2),
    lineHeight: "1.2rem",
    border: "none", // Reset all borders
    borderRight: `1px solid ${theme.palette.divider}`, // Only add right border
    "&:last-child": {
      borderRight: "none", // Remove right border from last column
    },
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    backgroundColor: theme.palette.common.white,
    wordBreak: "break-word",
    whiteSpace: "pre-wrap",
    textAlign: "center", // Centers text in the body cells
    verticalAlign: "middle", // Centers text vertically
    padding: theme.spacing(1.2),
    border: "none", // Reset all borders
    borderRight: `1px solid ${theme.palette.divider}`, // Only add right border
    "&:last-child": {
      borderRight: "none", // Remove right border from last column
    },
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:hover": {
    backgroundColor: "rgba(249, 84, 84, 0.04)",
    transition: "background-color 0.2s ease",
  },
}));
function TablePaginationActions(props) {
  const { count, page, rowsPerPage, onPageChange, currentItems } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  const disableButtons = currentItems.length === 0;

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={disableButtons || page === 0}
        aria-label="first page"
      >
        <FirstPageIcon />
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={disableButtons || page === 0}
        aria-label="previous page"
      >
        <KeyboardArrowLeft />
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={disableButtons || page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        <KeyboardArrowRight />
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={disableButtons || page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        <LastPageIcon />
      </IconButton>
    </Box>
  );
}

export default function CrawledSessionRecordsTable() {
  const {
    setIsLoadings,
    selectedPlatform,
    setSelectedPlatform,
    settogglefilteredCrawledData,
    isSpecificDateEnabled,
    setIsSpecificDateEnabled,
    setDateWiseData,
    isLoadings,
    data,
    setData,
    itemsPerPage,

    statusMap,
  } = useContext(MyContext);

  const token = localStorage.getItem("Token");

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(true); // New loading state
  const [loader, setLoader] = useState(false);
  const fetchData = async (platform, isIntervalCall = false) => {
    settogglefilteredCrawledData(false);

    // Only reset specific date-related states if not an interval call
    if (!isIntervalCall) {
      setIsSpecificDateEnabled(false);
      setDateWiseData([]);
    }

    let stringParams = {
      platform: platform === "All" ? "" : platform.toLowerCase(),
    };

    const hexHash = generateHash(stringParams);

    const headers = {
      // Security Headers
      "X-XSS-Protection": "1; mode=block",
      Authorization: `Bearer ${token}`,
      "X-Content-Type-Options": "nosniff",
      "X-Frame-Options": "DENY",
      "Referrer-Policy": "strict-origin-when-cross-origin",
      "Permissions-Policy": "camera=(), microphone=(), geolocation=()",

      // Standard Headers
      "Content-Type": "application/json",
    };

    try {
      setLoader(true);
      const baseUrl = `/api/sessionLogs`;

      // Construct the query parameter for platform
      // Construct the query parameters
      // Construct the query parameters
      const params =
        platform === "All"
          ? { HPPcode: hexHash }
          : { platform: platform.toLowerCase(), HPPcode: hexHash };

      // Fetch data based on the query parameters
      const result = await api.get(baseUrl, { headers, params });

      // Set the result data directly (new response format is an array)
      if (Array.isArray(result?.data)) {
        setData(result.data); // Use the response array directly
        setLoader(false);
      } else {
        console.error("Unexpected response format:", result?.data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoader(false);
    }
  };

  let interval = 0;

  useEffect(() => {
    // Reset current page to 1 when switching platforms
    setCurrentPage(1);
    setPage(0); // Reset the pagination for TablePagination

    fetchData(selectedPlatform);
    if (isSpecificDateEnabled === false) {
      interval = setInterval(() => {
        fetchData(selectedPlatform, true);
      }, 60000);
    }

    return () => clearInterval(interval);
  }, [selectedPlatform]);
  const handlePlatformChange = (event) => {
    setSelectedPlatform(event.target.value);
  };

  const indexOfLastItem = (page + 1) * rowsPerPage;
  const indexOfFirstItem = indexOfLastItem - rowsPerPage;
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem); // Adjusted to use the updated data array
  const totalPages = Math.ceil(data.length / rowsPerPage);

  // Debug current items

  const { navigationCount, setNavigationCount } = useContext(MyContext);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const tableContainerRef = useRef();

  const truncateText = (text, maxLength) => {
    if (text.length > maxLength) {
      return text.substring(0, maxLength) + "...";
    }
    return text;
  };

  const toggleFullscreen = () => {
    setIsFullscreen(!isFullscreen);
    if (!isFullscreen) {
      tableContainerRef.current.requestFullscreen();
      setIsFullscreen(isFullscreen);
    } else if (document.fullscreenElement) {
      document.exitFullscreen();
    }
  };

  const handleChangePage = (event, newPage) => {
    if (newPage > page) {
      setNavigationCount((prev) => prev + 1);
    } else {
      setNavigationCount((prev) => prev - 1);
    }
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); // Reset to the first page when changing rows per page
  };

  // const paginatedData = Array.isArray(analysisData)
  //   ? analysisData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
  //   : [];

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const options = {
      weekday: "short",
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true, // Ensures AM/PM format
    };
    return date.toLocaleString("en-US", options);
  };

  setTimeout(() => {
    setIsLoading(false);
  }, 30);

  return (
    <main>
      <div style={{ width: "100%", padding: "15px" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            padding: "10px 24px 0px 24px",
            marginBottom: "20px",
            alignItems: "center",
          }}
        >
          <div style={{ textAlign: "left" }} className="basic-Header">
            Session Logs
          </div>
          <div>
            <FormControl
              variant="outlined"
              style={{
                width: "200px",
                background: "white",
                borderRadius: "8px",
              }}
            >
              <InputLabel>Platform</InputLabel>
              <Select
                value={selectedPlatform}
                onChange={handlePlatformChange}
                label="Platform"
              >
                <MenuItem value="All">All</MenuItem>
                <MenuItem value="Twitter">Twitter</MenuItem>
                <MenuItem value="YouTube">YouTube</MenuItem>
                <MenuItem value="Instagram">Instagram</MenuItem>
                <MenuItem value="Facebook">Facebook</MenuItem>
                <MenuItem value="Threads">Threads</MenuItem>
              </Select>
            </FormControl>
          </div>
        </div>
        {loader ? (
          <div
            className="three-body-problem"
            style={{
              height: "80vh",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div className="three-body">
              <div className="three-body__dot"></div>
              <div className="three-body__dot"></div>
              <div className="three-body__dot"></div>
            </div>
          </div>
        ) : (
          <Box
            sx={{
              width: isFullscreen ? "100vw" : "auto",
              height: isFullscreen ? "100vh" : "auto",
              display: "flex",
              flexDirection: "column",
              justifyContent: "end",
              overflow: "hidden",
              position: "relative",
              zIndex: 0,
              borderRadius: "15px",
              boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.25)", // Added box shadow
              // marginTop: "30px",
            }}
          >
            <TableContainer
              component={Paper}
              sx={{
                flex: "1 1 auto",
                maxHeight: "calc(75vh - 33px)",
                // minHeight: "calc(75vh - 33px)",
                overflowY: "auto",
                zIndex: "-1",

                scrollbarWidth: "none", // For Firefox
                "&::-webkit-scrollbar": {
                  display: "none", // For Chrome, Safari, and Edge
                },
              }}
              ref={tableContainerRef}
            >
              <Table
                stickyHeader
                sx={{ minWidth: 1200, tableLayout: "fixed" }}
                aria-label="customized table"
                // ref={tableRef}
              >
                <TableHead>
                  <TableRow>
                    <StyledTableCell sx={{ width: 40 }}>S.No</StyledTableCell>
                    {/* Serial Number Column */}
                    <StyledTableCell sx={{ width: 75 }}>
                      Session ID
                    </StyledTableCell>
                    <StyledTableCell sx={{ width: 75 }}>
                      Analysis
                    </StyledTableCell>
                    <StyledTableCell sx={{ width: 115 }}>
                      Date Created
                    </StyledTableCell>
                    <StyledTableCell sx={{ width: 80 }}>
                      Post Count
                    </StyledTableCell>
                    <StyledTableCell sx={{ width: 80 }}>
                      Unlawful Post
                    </StyledTableCell>
                    <StyledTableCell sx={{ width: 100 }}>
                      Keywords
                    </StyledTableCell>
                    <StyledTableCell sx={{ width: 70 }}>Status</StyledTableCell>
                    <StyledTableCell sx={{ width: 80 }}>
                      Platform
                    </StyledTableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {currentItems.length === 0 && !isLoading && (
                    <StyledTableRow>
                      <StyledTableCell
                        colSpan={7}
                        sx={{ textAlign: "center", fontWeight: "bold" }}
                      >
                        Data is not available
                      </StyledTableCell>
                    </StyledTableRow>
                  )}
                  {currentItems.map((item, index) => (
                    <StyledTableRow key={index}>
                      <StyledTableCell>
                        {isLoading ? (
                          <Skeleton width="40%" />
                        ) : (
                          page * rowsPerPage + index + 1
                        )}
                      </StyledTableCell>

                      <StyledTableCell>
                        {isLoading ? (
                          <Skeleton width="80%" />
                        ) : (
                          item.sessionId || "N/A"
                        )}
                      </StyledTableCell>
                      <StyledTableCell>
                        {isLoading ? (
                          <Skeleton width="80%" />
                        ) : (
                          item.type || "N/A"
                        )}
                      </StyledTableCell>
                      <StyledTableCell>
                        {isLoading ? (
                          <Skeleton width="60%" />
                        ) : item.dateCreated ? (
                          formatDate(item.dateCreated)
                        ) : (
                          "N/A"
                        )}
                      </StyledTableCell>
                      <StyledTableCell>
                        {isLoading ? (
                          <Skeleton width="50%" />
                        ) : (
                          item.postCount || "None"
                        )}
                      </StyledTableCell>
                      <StyledTableCell>
                        {isLoading ? (
                          <Skeleton width="50%" />
                        ) : (
                          item.unlawfulCount || "None"
                        )}
                      </StyledTableCell>
                      <StyledTableCell>
                        {isLoading ? (
                          <Skeleton width="80%" />
                        ) : (
                          item.keywords || "None"
                        )}
                      </StyledTableCell>
                      <StyledTableCell
                        style={{
                          color: statusMap[item.status]?.color || "black",
                        }}
                      >
                        {isLoading ? (
                          <Skeleton width="40%" />
                        ) : (
                          statusMap[item.status]?.text || "None"
                        )}
                      </StyledTableCell>

                      <StyledTableCell>
                        {isLoading ? (
                          <Skeleton width="40%" />
                        ) : (
                          item.platform || "N/A"
                        )}
                      </StyledTableCell>
                    </StyledTableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                outline: "none",
                backgroundColor: "white",
                borderBottomRightRadius: "15px",
                borderBottomLeftRadius: "15px",
              }}
            >
              <Tooltip title="Expand">
                <Button onClick={toggleFullscreen}>
                  {isFullscreen ? (
                    <FontAwesomeIcon icon={faMinimize} fontSize={"15px"} />
                  ) : (
                    <FontAwesomeIcon icon={faExpand} fontSize={"20px"} />
                  )}
                </Button>
              </Tooltip>
              <TablePagination
                component="div"
                rowsPerPageOptions={[10, 20, 50, 100]} // Ensure the default value is included
                count={data.length} // Total number of rows
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                ActionsComponent={(props) => (
                  <TablePaginationActions
                    {...props}
                    currentItems={currentItems}
                  />
                )}
                sx={{ minWidth: "auto" }}
              />
            </Box>
          </Box>
        )}
      </div>
    </main>
  );
}
